export default __webpack_public_path__ + "static/media/edit_icon_blue.c7fa7779.svg";